import { Container } from "@mui/material";
import NavigationBar from "./NavigationBar";
import "../styles.css";

export default function PageLayout({ children, maxWidth = "lg", sx = {} }) {
  return (
    <div className="gradient-background">
      <NavigationBar />
      <Container
        maxWidth={maxWidth}
        sx={{ marginTop: "64px", paddingTop: "24px", paddingBottom: "48px", ...sx }}
      >
        {children}
      </Container>
    </div>
  );
}
